<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="maxWidth"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<slot name="activator" :attrs="attrs" :dialog="dialog">
				<v-btn icon v-bind="attrs" v-on="{ ...dialog }">
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</slot>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-container>
					<v-expansion-panels v-model="panel" multiple>
						<v-expansion-panel>
							<!-- <v-expansion-panel-header>Основна інформація</v-expansion-panel-header> -->
							<v-expansion-panel-header>
								<v-toolbar flat>
									<!-- <v-app-bar-nav-icon>
										<v-icon>mdi-car</v-icon>
									</v-app-bar-nav-icon> -->
									<v-toolbar-title>Основна інформація</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn outlined @click.stop="onLoadFile" >
										<v-icon>mdi-import</v-icon>
										Імпорт
									</v-btn>
								</v-toolbar>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-form ref="form">
									<v-row>
										<v-col cols="12" md="8">
											<v-text-field
												v-model="item.name"
												:label="$vuetify.lang.t('$vuetify.name') | capitalize"
												clearable
												outlined
												dense
												hide-details="auto"
												:rules="[rules.required]"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="4">
											<v-text-field
												v-model="item.code"
												:label="$vuetify.lang.t('$vuetify.code') | capitalize"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="2">
											<v-text-field
												v-model="item.year"
												label="Рік"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="2">
											<v-text-field
												v-model="item.quarter"
												label="Квартал"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
									</v-row>
								</v-form>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>
								<v-toolbar flat>
									<!-- <v-app-bar-nav-icon>
										<v-icon>mdi-car</v-icon>
									</v-app-bar-nav-icon> -->
									<!-- <v-toolbar-title>{{ title_products }}</v-toolbar-title> -->
									<v-toolbar-title>Показники</v-toolbar-title>
									<v-spacer></v-spacer>

									<!-- <v-divider vertical></v-divider> -->
									<v-btn outlined class="mx-3" @click="onIndicatorsClear()" >
										<v-icon>mdi-broom</v-icon>
										Очистити
									</v-btn>
									
									<!-- <v-divider vertical></v-divider> -->
									
									<!-- <v-btn outlined  class="mx-1" v-if="products.length" @click="onExport">
										<v-icon left>mdi-export</v-icon>
										Експорт
									</v-btn> -->

									<!-- <z-import-excel 
										:headers="headers"
										:fields="fields"
										@ok="addProducts"
									>
										<template v-slot:activator="props">
											<v-btn outlined class="mx-3" v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
												<v-icon left>mdi-import</v-icon>
												Імпорт
											</v-btn>
										</template>
									</z-import-excel> -->

									<v-divider vertical inset></v-divider>

									<!-- <z-detail 
										:category="item.category"
										@ok="createProduct"
									>
										<template v-slot:activator="props">
											<v-btn outlined v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
												<v-icon left>mdi-plus</v-icon>
												Додати
											</v-btn>
										</template>
									</z-detail> -->
								</v-toolbar>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-tabs v-model="tab">
								<v-tab v-for="(report, i) in item.reports" :key="i">
									{{ report.name }}
								</v-tab>
							</v-tabs>
							<v-tabs-items v-model="tab">
								<v-tab-item v-for="(report, i) in item.reports" :key="i">
									<v-data-table
										:items="report.indicators"
										:headers="headers"
									>
										<template v-slot:[`item.amount`]="{ item }">
											<span>{{ item.amount | toCurrencyUAH }}</span>
										</template>					
									</v-data-table>
								</v-tab-item>
							</v-tabs-items>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-file-input
			v-model="file"
			ref="file"
			class="d-none"
			accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			@change="changeFile"
		></v-file-input>

		<!-- <z-pdf-estimate ref="pdfEstimate" :item="itemPdf"></z-pdf-estimate> -->

		<!-- <z-dialog-estimate ref="dialogEstimate" :park="item" @ok="addEstimate" tooltip="create">
			<template v-slot:activator="props"></template>
		</z-dialog-estimate> -->

	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDate from '@/views/components/control/Date2'
//import zDetail from '@/views/dialogs/details/InsuranceIndicatorProduct'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete2'
import zImportExcel from '@/views/components/dialogs/ImportExcel'
//import zPdfEstimate from '@/views/pdf/ProductParkEstimate'

import * as XLSX from 'xlsx'; //https://www.npmjs.com/package/xlsx

export default {
	name: 'DialogDetailInsuranceIndicator',
	mixins: [mixin],
	components: { zDate
		//,zDetail
		//, zDialogEstimate, zDialogDetailEstimate
		,zConfirmDelete, zImportExcel
		//, zPdfEstimate
	},
	data: () => ({
		file: null,
		panel: [0, 1],
		tab: 0,

		item: {
			code: null,
			name: null,
			year: null,
			quarter: null,
			indicators: [],
			reports: []
		},

		indicators_selected: [],

		headers: [
			//{ text: 'ID', value: 'id', align: 'd-none', sortable: true},
			//{ text: '№', value: 'nop', sortable: true},
			{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Страхова компанія', value: 'company.name', sortable: true},
			{ text: 'Звітність', value: 'report.name', sortable: true},
			{ text: 'Тип', value: 'type.name', sortable: true},
			{ text: 'Категорія', value: 'category.name', sortable: true},
			{ text: 'Значення', value: 'amount', sortable: true},
			{ text: '', value: 'actions', sortable: false },
		],

		/* search_seller: null, */


		snackbar: {
			visible: false,
			text: null,
			timeout: 2000,
			color: "success"
		},

		/* loadings: {
			types: false,
			categories: false,
			directions: false,
			sources: false,
			currencies: false,
		}, */

		/* types: [],
		categories: [],
		directions: [],
		sources: [],
		currencies: [],
		sellers: [],
		products: [], */
	}),

	props: {
		title: 				{ type: String, default: 'Показники діяльності страховиків' },
		icon: 				{ type: String, default: 'mdi-script-text' },
		maxWidth: 			{ type: Number, default: 800 },
	},

	
	watch: {
		search_seller (val) {
			// Items have already been loaded
			if (val < 3) return

			this.loadSellers(val)
		}
    },

	computed: {
		id() {
			return this.item?.id ? this.item.id : null
		},
	},

	created () {
		//console.log(this.$options.name, 'created')
		this.fullscreen = true;
	},

	methods: {
		onLoadFile() {
			this.$refs.file.$refs.input.click()
		},

		changeFile(files) {
			if(Array.isArray(files)) {
				files.forEach((file) => this.processFile(file))
			} else {
				this.processFile(files)
			}
		},

		/**
		 * Обробка файлу
		 * @param file 
		 */
		processFile(file) {
			console.log(this.$options.name, 'processFile')

			if (file) {
				this.item.name = file.name;
				const fileName = file.name;
				const lastDotIndex = fileName.lastIndexOf('.');
				const fileExtension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex + 1) : null
				
				switch(fileExtension) {
					case 'xlsx': this.processWorkbook(file); break;
				}
			}
		},

		/**
		 * Обробка файлу Excel
		 * @param file 
		 */
		processWorkbook(file) {
			console.log(this.$options.name, 'processWorkbook')

			let that = this

			if (file) {
				const reader = new FileReader();

				reader.onload = (e) => {
					//console.log(this.$options.name, 'processWorkbook', 'XLSX', XLSX)
					this.setIndicators()

					const bstr = e.target.result;
					const workbook = XLSX.read(bstr, { type: 'binary' });
					workbook.SheetNames.forEach(name => {
						const worksheet = workbook.Sheets[name];

						console.log(this.$options.name, 'processWorkbook', 'WorksheetName', name)

						let report = {
							name: name,
							indicators: []
						}

						//let items = null
						switch(name) {
							case 'СК 01.04': report.indicators = this.processWorksheetCK(worksheet, name) ; break;
							case 'СК 01.07': report.indicators = this.processWorksheetCK(worksheet, name) ; break;
							case 'СК 01.10': report.indicators = this.processWorksheetCK(worksheet, name) ; break;
							case 'СК 01.01': report.indicators = this.processWorksheetCK(worksheet, name) ; break;
							case 'IRB': report.indicators = this.processWorksheetIRB(worksheet, name) ; break;
							case 'IRPL(клієнти)': report.indicators = this.processWorksheetIRPL(worksheet, name) ; break;
							case 'IR20': report.indicators = this.processWorksheetIR20(worksheet, name) ; break;
						}

						/* if(items) {
							this.addIndicators(items)
						} */

						that.item.reports.push(report)
					});

					//console.log(that.$options.name, 'processWorkbook', 'file', that.file)
					//console.log(that.$options.name, 'processWorkbook', 'item', that.item)
				}

				reader.readAsArrayBuffer(file);
			}
		},

		detailArray(data, len) {
			let arr = [...data];

			len = len ? len : arr.length

			let lastValidValue = null;
			for (let i = 0; i < len; i++) {
				// Перевіряємо, чи комірка порожня (null, undefined або пустий рядок)
				if (arr[i] !== null && arr[i] !== undefined && arr[i] !== '') {
					// Якщо значення є — запам'ятовуємо його
					lastValidValue = arr[i];
				} else {
					// Якщо значення порожнє — підставляємо те, що запам'ятали раніше
					arr[i] = lastValidValue;
				}
			}

			return arr
		},

		processWorksheetCK(worksheet, worksheetName) {
			//console.log(this.$options.name, 'processWorksheetCK', 'worksheet', worksheet)
			const report_code = worksheetName.replace(/\s|\./g, '');
			const data 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

			const arr1 = this.detailArray(data[3], data[4].length)
			const arr2 = data[4]

			// 1. Збираємо унікальні індекси з обох масивів
			const allIndexes = new Set([
				...Object.keys(arr1).map(Number), 
				...Object.keys(arr2).map(Number)
			]);

			// 2. Будуємо новий масив
			const categories = Array.from(allIndexes).reduce((result, index) => {
				const val1 = arr1[index];
				const val2 = arr2[index];

				if (val1 !== undefined && val2 !== undefined) {
					// Умова 1: Обидва індекси існують -> Конкатенація рядків
					result[index] = String(val1) + String(val2);
				} else if (val1 !== undefined) {
					// Умова 2: Індекс є тільки в першому масиві
					result[index] = val1;
				} else if (val2 !== undefined) {
					// Умова 3: Індекс є тільки в другому масиві
					result[index] = val2;
				}

				return result;
			}, []);

			//console.log(categories);

			//Формування переліку страхових компаній
			//const rows = data.slice(0, 8);

			let companies = [];
			data.forEach((row, r) => {
				let nop = row[0], code = row[1], name = row[2];

				if(!isNaN(nop) && code.length == 8) {
					companies.push({ nop, code, name })
				}
			})

			//console.log(this.$options.name, 'processWorksheetCK', 'companies', companies)

			let result = [];
			data.forEach((row, r) => {
				let nop = row[0], code = row[1], name = row[2];

				if(!isNaN(nop) && code.length == 8) {
					categories.forEach((coll, c) => {
						if(c >= 3 ) {
							let amount = row[c]
							result.push({
								code: `${report_code}_r${r+1}:c${c+1}(${this.convertToExcelColumn(c+1)})`,
								report: { code: report_code, name: worksheetName },
								company: { nop, code, name },
								type: { nop: c, name: coll },
								amount: amount
							});
						}
					})
				}
			})

			//console.log(this.$options.name, worksheetName, 'result', result)

			return result
		},
		
		processWorksheetIRB(worksheet, worksheetName) {
			//console.log(this.$options.name, 'processWorksheetIRB')
			const report_code = worksheetName.replace(/\s|\./g, '');
			const data 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

			//Дозаповнення відсутніх елементів масиву значеннями попередніх комірок
			const arr1 = this.detailArray(data[3], data[5].length)
			const arr2 = this.detailArray(data[4], data[5].length)
			const arr3 = data[5]

			//console.log(this.$options.name, 'processWorksheetIRB', 'arr1', arr1)
			//console.log(this.$options.name, 'processWorksheetIRB', 'arr2', arr2)
			//console.log(this.$options.name, 'processWorksheetIRB', 'arr3', arr3)

			let result = [];
			data.forEach((row, r) => {
				if(r > 8) {
					let type_nop = row[0], type_name = row[1];

					if(!isNaN(type_nop)) {
						//companies.push({ nop, code, name })
						arr3.forEach((coll, c) => {
							if(c >= 2 ) {
								let amount = row[c], company_code = arr1[c], company_name = arr2[c], category_name = arr3[c];
								result.push({
									code: `${report_code}_r${r+1}:c${c+1}(${this.convertToExcelColumn(c+1)})`,
									report: { code: report_code, name: worksheetName },
									company: { code: company_code, name: company_name },
									type: { nop: type_nop, name: type_name },
									category: { name: category_name },
									amount: amount
								});
							}
						})
					}
				}
			})

			//console.log(this.$options.name, worksheetName, 'result', result)

			return result
		},
		
		processWorksheetIRPL(worksheet, worksheetName) {
			//console.log(this.$options.name, 'processWorksheetIRPL')
			const report_code = worksheetName.replace(/\s|\./g, '');
			const data 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

			//Дозаповнення відсутніх елементів масиву значеннями попередніх комірок
			const arr1 = this.detailArray(data[4], data[6].length)
			const arr2 = this.detailArray(data[5], data[6].length)
			const arr3 = data[6]

			//console.log(this.$options.name, 'processWorksheetIRB', 'arr1', arr1)
			//console.log(this.$options.name, 'processWorksheetIRB', 'arr2', arr2)
			//console.log(this.$options.name, 'processWorksheetIRB', 'arr3', arr3)

			let result = [];
			data.forEach((row, r) => {
				if(r > 9) {
					let type_nop = row[0], type_name = row[1];

					if(!isNaN(type_nop)) {
						//companies.push({ nop, code, name })
						arr3.forEach((coll, c) => {
							if(c >= 2 ) {
								let amount = row[c], company_code = arr1[c], company_name = arr2[c], category_name = arr3[c];
								result.push({
									code: `${report_code}_r${r+1}:c${c+1}(${this.convertToExcelColumn(c+1)})`,
									report: { code: report_code, name: worksheetName },
									company: { code: company_code, name: company_name },
									type: { nop: type_nop, name: type_name },
									category: { name: category_name },
									amount: amount
								});
							}
						})
					}
				}
			})

			//console.log(this.$options.name, worksheetName, 'result', result)

			return result
		},
		
		processWorksheetIR20(worksheet, worksheetName) {
			//console.log(this.$options.name, 'processWorksheetIR20')
			const report_code = worksheetName.replace(/\s|\./g, '');
			const data 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

			//Дозаповнення відсутніх елементів масиву значеннями попередніх комірок
			const arr1 = this.detailArray(data[3], data[5].length)
			const arr2 = this.detailArray(data[4], data[5].length)
			const arr3 = data[5]

			//console.log(this.$options.name, 'processWorksheetIRB', 'arr1', arr1)
			//console.log(this.$options.name, 'processWorksheetIRB', 'arr2', arr2)
			//console.log(this.$options.name, 'processWorksheetIRB', 'arr3', arr3)

			let result = [];
			data.forEach((row, r) => {
				if(r > 6) {
					let type_nop = row[0], type_name = row[1];

					if(!isNaN(type_nop)) {
						//companies.push({ nop, code, name })
						arr3.forEach((coll, c) => {
							if(c >= 2 ) {
								let amount = row[c], company_code = arr1[c], company_name = arr2[c], category_name = arr3[c];
								result.push({
									code: `${report_code}_r${r+1}:c${c+1}(${this.convertToExcelColumn(c+1)})`,
									report: { code: report_code, name: worksheetName },
									company: { code: company_code, name: company_name },
									type: { nop: type_nop, name: type_name },
									category: { name: category_name },
									amount: amount
								});
							}
						})
					}
				}
			})

			//console.log(this.$options.name, worksheetName, 'result', result)

			return result
		},
		
		find(id) {
			var that = this
			this.loading = true
			return axios.get(`/insurance/indicator/${id}`).then(response => {
				//console.log(that.$options.name, 'find','response.data', response.data)
				that.item = response.data
			}, error => { console.log('error', error)}).finally(() => (this.loading = false));
		},

		create() {
			var that = this
			this.loading = true
			return axios.post(`/insurance/indicator`, this.item).then(response => {
				//console.log('index', 'create','response.data', response.data)
				that.item = response.data
			}, error => { console.log(error)}).finally(() => (this.loading = false));
		},

		update(id) {
			var that = this
			this.loading = true
			return axios.put(`/insurance/indicator/${id}`, this.item).then(response => {
				//console.log('index', 'update','response.data', response.data)
				that.item = response.data
			}, error => { console.log(error)}).finally(() => (this.loading = false));
		},

		save() {
			//return this.id ? this.update(this.selected) : this.create();
			return this.item?.id ? this.update(this.item.id) : this.create();
		},

		onOpen () {
			//console.log(this.$options.name, 'onOpen', 'selected', this.selected)
			if(this.selected?.id) {
				this.find(this.selected.id)
			}
		},

		/* onSave() {
			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(()=>{
					//this.dialog = false
					this.snackbar.text = 'Дані збережено'
					this.snackbar.visible = true
					this.snackbar.color = 'success'
				}).finally(() => {
					this.loading = false
				});
			} else {
				this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error'
			}
		}, */

		onOK() {
			console.log(this.$options.name, 'onOK', 'item', this.item)

			if(this.$refs.form.validate()) {
				this.loading = true
				this.save().then(() => { 
					this.$emit('ok', this.item); 
					this.dialog = false
				}).finally(() => { this.loading = false })
			}
		},

		onIndicatorsClear() {
			this.setIndicators()
			//this.item.indicators = [];
		},

		setIndicators(items) {
			this.item.indicators = items ? items : [];
		},

		addIndicators(items) {
			//console.log(this.$options.name, 'addIndicators', 'items', items)

			this.item.indicators.push(...items);
		},

		createIndicator(item) {
			//console.log(this.$options.name, 'item', item)
			this.item.indicators.push(item);
		},

		editIndicator(selected, item) {
			//console.log(this.$options.name, 'selected', selected)
			//console.log(this.$options.name, 'item', item)

			const index = this.item.indicators.indexOf(selected)
			this.item.indicators.splice(index, 1, item)
		},

		removeIndicator(item) {
			//console.log(this.$options.name, 'removeProduct', 'data', data)
			const index = this.item.indicators.indexOf(item)
			this.item.indicators.splice(index, 1);
		},

		deleteIndicator(item) {
			/* let that = this
			return axios.delete(`/insurance/indicator/${item.id}`).then(response => {
				//console.log(this.$options.name, 'deleteIndicator','response.data', response.data)
				that.removeIndicator(item)
			}, error => {
				//if()
				console.log(error)
			}) */
		},

		onDeleteIndicator(item) {
			if(item?.id) {
				this.deleteIndicator(item)
			} else {
				this.removeIndicator(item)
			}
		},

		onDeleteIndicatorSelected() {
			this.select.products.forEach((item) => {
				if(item?.id) {
					this.deleteIndicator(item)
				} else {
					this.removeIndicator(item)
				}
			})

			this.select.indicators = []
		},


		/**
		 * Функція для перетворення цифрового значення в літерні назви стовпців Excel (наприклад, 1 → A, 2 → B, 27 → AA)
		 * @param num 
		 */
		convertToExcelColumn(num) {
			let column = '';
			let tempNum = num;

			while (tempNum > 0) {
				let remainder = tempNum % 26;
				
				// Якщо залишок 0, це Z.
				// Зменшуємо tempNum, щоб уникнути нескінченного циклу і перейти до попереднього "розряду"
				if (remainder === 0) {
					column = 'Z' + column;
					tempNum = (tempNum / 26) - 1;
				} else {
					// Використовуємо ASCII-код, щоб отримати літеру (65 - це 'A')
					column = String.fromCharCode(64 + remainder) + column;
					tempNum = Math.floor(tempNum / 26);
				}
			}

			return column;
		},

		/**
		 * Функція, що перетворює літерне позначення стовпця Excel на його числовий еквівалент
		 * @param column 
		 */
		convertFromExcelColumn(column) {
			let result = 0;
			let multiplier = 1;

			// Проходимо по рядку справа наліво
			for (let i = column.length - 1; i >= 0; i--) {
				// Визначаємо числове значення літери (A=1, B=2, ...)
				const charValue = column.charCodeAt(i) - 64;
				
				// Додаємо значення, помножене на відповідну степінь 26
				result += charValue * multiplier;
				
				// Збільшуємо множник для наступної ітерації (26^0, 26^1, 26^2...)
				multiplier *= 26;
			}
			
			return result;
		},
	},
}
</script>